import { render, staticRenderFns } from "./sendCodePage.vue?vue&type=template&id=5353df81&scoped=true"
import script from "./sendCodePage.vue?vue&type=script&lang=js"
export * from "./sendCodePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5353df81",
  null
  
)

export default component.exports